<template>
  <div>
    <loading
      class="custom-loading-overlay"
      :active="isLoading"
      :color="loadingColor"
      :isFullPage="true"
    ></loading>
    <div class="row mt-3" v-if="user.usuario_nome != ''">
      <div class="col-12 font-30">
        Olá, {{ user.usuario_nome.split(" ")[0] }}!
      </div>
    </div>

    <div class="row mt-4">
      <div class="centered my-custom-column">
        <vue-flux
          :options="fluxOptions"
          :images="fluxImages"
          :transitions="fluxTransitions"
          heigth="50"
          ref="slider"
        >
        </vue-flux>
      </div>
    </div>
    <div class="row mt-3" v-if="statusUltimaOcorrencia">
      <div class="menu-list my-custom-column">
        <div class="card card-style rounded-m p-3 py-2 mb-0 pisca">
          <router-link
            :to="'/visualizar-atendimento/' + ocorrencias[0].ocorrencia_id"
          >
            <i
              class="gradient-yellow shadow-bg shadow-bg-xs bi bi-star-fill"
            ></i>
            <span
              >Ir para o atendimento em andamento
              <span
                class="badge badge-pill badge-danger"
                v-if="ocorrencias[0].qtd_messages > 0"
                >Você tem {{ ocorrencias[0].qtd_messages }} novas
                mensagens</span
              ></span
            >
            <i class="bi bi-chevron-right"></i>
          </router-link>
        </div>
      </div>
    </div>

    <div class="row mt-3" v-else>
      <div class="menu-list my-custom-column">
        <div class="card card-style rounded-m p-3 py-2 mb-0">
          <router-link to="/solicitar-atendimento">
            <i
              class="gradient-green shadow-bg shadow-bg-xs bi bi-telephone-fill"
            ></i>
            <span>Chamar SAMU</span>
            <i class="bi bi-chevron-right"></i>
          </router-link>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="menu-list my-custom-column">
        <div class="card card-style rounded-m p-3 py-2 mb-0">
          <router-link to="/ultimas_solicitacoes">
            <i class="gradient-red shadow-bg shadow-bg-xs fas fa-ambulance"></i>
            <span>Meus últimos atendimentos</span>
            <i class="bi bi-chevron-right"></i>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import { VueFlux, FluxPagination, Transitions } from "vue-flux";
export default {
  data() {
    return {
      user: {
        usuario_nome: "  ",
      },
      fluxOptions: {
        autoplay: true,
      },
      fluxImages: [
        require("@/assets/images/banner1.png"),
        require("@/assets/images/banner2.jpeg"),
        require("@/assets/images/banner3.png"),
      ],
      fluxTransitions: {
        transitionBook: Transitions.transitionSlide,
      },
      isLoading: false,
      loadingColor: "#5D9CEC",
      /* ocorrencias: {
        latitude: 0,
        longitude: 0,
        queixa_principal: "",
        ip: "",
        paciente_id: 0,
        usuario_solicitante_id: 0,
        paciente: {
          nome_paciente: '',
        },
      }, */
      ocorrencias: [],
      statusUltimaOcorrencia: 0,
      usr_id: {
        usuario_id: "",
      },
      usuario_nome: "",
    };
  },
  computed: {
    exibirStatus() {
      return this.ocorrencias.map((ocorrencia) => {
        if (ocorrencia.status === 0) {
          return "Solicitado";
        } else if (ocorrencia.status === 1) {
          return "Em Andamento";
        } else if (ocorrencia.status === 2) {
          return "Finalizado";
        } else if (ocorrencia.status === 3) {
          return "Cancelado";
        } else {
          return ocorrencia.status.toString();
        }
      });
    },
  },
  methods: {
    /* changeStatusReceive(object) {
      const self = this;
      const api = self.$store.state.api + "teste";

      self.isLoading = true;

      self.$http
        .post(api, object)
        .then((response) => {})
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    }, */
    view(id) {
      const self = this;
      /* self.isLoading = true */
      this.$router.push("/visualizar-atendimento/" + id);
      /* this.$router.push({
        path: this.$router + "/editar-paciente/" + id,
      }); */
    },
    getOcorrencias(id) {
      const self = this;
      // self.isLoading = true;

      this.usr_id.usuario_id = Number(id);
      const api =
        self.$store.state.api + "usuario-ocorrencias?orderByDesc=createdAt";

      axios
        .post(api, this.usr_id)
        .then((response) => {
          self.user = self.$store.state.user;
          self.ocorrencias = response.data;
          if (self.ocorrencias[0].data_fim_atendimento == null) {
            self.statusUltimaOcorrencia = true;
          }
          self.isLoading = false;

          var intervalSla = setInterval(() => {
            clearInterval(intervalSla);
            self.getOcorrencias(id);
          }, 4000);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
          self.isLoading = false;
        })
        .finally(() => {
          self.isLoading = false;
        });
    },
  },
  components: { Loading, VueFlux, FluxPagination },
  props: {},
  mounted() {
    const self = this;

    self.isLoading = true;

    var id = localStorage.getItem("usuario_id");

    self.getOcorrencias(id);

    this.authenticated = this.$store.getters.authenticated;

    if (Notification.permission !== "granted") {
      Notification.requestPermission();
    }

    $("body").removeClass("top-navigation");
    $("body").removeClass("custom-login");

    $("#menu-main").removeClass("show");
    $(".offcanvas-backdrop.show").removeClass("show");
    /* $(".theme-light").removeAttribute("style","overflow: hidden; padding-right: 0px;"); */
    document.body.setAttribute("style", null);

    /*  var usr_nome = localStorage.getItem('usuario_nome');
    this.usuario_nome = usr_nome; */
  },
};
</script>
<style scoped>
/* CUSTOMIZACOES VUE LOADING */
.custom-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0);
  backdrop-filter: blur(3px);
  opacity: 0.98;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.custom-loading-spinner {
  width: 100px;
  height: 100px;
  z-index: 10000;
}

/* CUSTOMIZACOES INPUTS */
.custom-input {
  border-radius: 0;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}

.input-group > .form-control {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  margin-bottom: 0;
}

.input-group > .form-control:focus {
  z-index: 3;
}

.custom-input-container {
  position: relative;
}

.custom-input {
  padding: 0.375rem 0.75rem;
  height: 2.714rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  box-shadow: 0 0.2rem 0.5rem rgba(0, 0, 0, 0.15);
  width: 100%;
}

.custom-input:focus {
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.botao-cadastrar {
  position: fixed;
  bottom: 0;
  width: 100%;
  padding-left: 10px;
  padding-right: 10px;
}

.sem-registros {
  position: fixed;
  bottom: 50%;
  width: 100%;
  /* padding-left: 10px;
  padding-right: 10px; */
}

.btn {
  width: 100% !important;
  background-color: rgb(21, 72, 138) !important;
  margin: 0px 15px 18px -29px;
}

h5 {
  font-weight: normal;
}
.my-custom-column {
  padding-left: 0;
  padding-right: 0;
  margin-left: 0;
  margin-right: 0;
  width: 100vw; /* 100% da largura da viewport */
}

.pisca {
  animation: animate 2.5s linear infinite;
}

@keyframes animate {
  0% {
    background-color: #fff;
  }

  50% {
    background-color: #ffea47d2;
  }

  100% {
    background-color: #fff;
  }
}

.badge-danger {
  color: #fff !important;
  background-color: #dc3545 !important;
}
.badge-pill {
  padding-right: 0.6em !important;
  padding-left: 0.6em !important;
  border-radius: 10rem !important;
}

.badge {
  display: inline-block !important;
  padding: 0.25em 0.4em !important;
  font-size: 75% !important;
  font-weight: 700 !important;
  line-height: 1 !important;
  text-align: center !important;
  white-space: nowrap !important;
  vertical-align: baseline !important;
  border-radius: 0.25rem !important;
  position: relative;
  top: -10px;
  left: 45px;
}
</style>


// WEBPACK FOOTER //
// src/components/Home.vue